import { render, staticRenderFns } from "./PaymentTypesReport.vue?vue&type=template&id=1c080a7a&scoped=true&"
import script from "./PaymentTypesReport.vue?vue&type=script&lang=js&"
export * from "./PaymentTypesReport.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTypesReport.vue?vue&type=style&index=0&id=1c080a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c080a7a",
  null
  
)

export default component.exports